// VERY IMPORTANT!
// Make sure you use descriptive names in the strings, otherwise there will be name clashes.
// In other words, we cannot re-use a name inside a string inside another redux component

export const API_V1_GET_CLIENTS_REQUEST = "API_V1_GET_CLIENTS_REQUEST",
  API_V1_GET_CLIENTS_SUCCESS = "API_V1_GET_CLIENTS_SUCCESS",
  API_V1_GET_CLIENTS_FAILURE = "API_V1_GET_CLIENTS_FAILURE";
